export default __webpack_public_path__ + "static/media/Bandeau 11.260cff57.jpg";